import { gtmService } from "../services/gtmService";
import { useGtmStore } from "../stores/useGtmStore";

export function useGtm() {
  const { initiated, setInitiated } = useGtmStore();

  function init(id: string) {
    if (!initiated) {
      gtmService.init(id);
      setInitiated(true);
    }
  }

  function event(event: string, more: { [key: string]: unknown }) {
    if (initiated) {
      gtmService.event({ event, ...more });
    }
  }

  return { init, event };
}
